import { useState, useEffect, useRef } from "react";

import { useAuthStore } from "../../store/authStore";
import { useLoaderStore } from "../../store/loaderStore";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";

import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import loginLogo from "../../assets/login.png";
import iworkkzlogo from "../../assets/iWORKKZ-White 3.png";
import attendanceIconWhite from "../../assets/attendance-icon-white.png";
import attendanceTextLogo from "../../assets/iAttendance text logo.svg";
import { ReactComponent as AttendanceTextLogo } from "../../assets/iAttendance text logo.svg";
import deskLogo from "../../assets/iworkkzlogo-desk.png";
import deskBg from "../../assets/Background-desk.jpg";

import fb from "../../assets/fb.png";
import linkedin from "../../assets/linkdln.png";
import insta from "../../assets/instagram.png";


import WaveBackground from "../../components/mobile/WaveBackground";

import "./Login.css";

export default function Login() {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoaderStore();
  const { user, login } = useAuthStore();

  const [companyCode, setCompanyCode] = useState("");
  const [employeeCode, setEmployeeCode] = useState("");
  const [password, setPassword] = useState("");
  const [showDesktopPassword, setShowDesktopPassword] = useState(false);
  const [showMobilePassword, setShowMobilePassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const loginLockRef = useRef(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loginLockRef.current) return;

    loginLockRef.current = true;
    setSubmitting(true);
    try {
      showLoader("mobile");
      await login(companyCode, employeeCode, password);
      // The authenticated-user effect below handles navigation once.
    } catch (error) {
      console.error("Login Error:", error);
      toast.error(error.message || "Unable to connect to server");
    } finally {
      loginLockRef.current = false;
      setSubmitting(false);
      hideLoader();
    }
  };

  // ─── Auto‑redirect if already logged in ──────────────
  useEffect(() => {
    if (user) {
      const isMobile = window.innerWidth < 768;
      if (isMobile) {
        navigate(
          user.role === 0
            ? "/user/mobile/dashboard"
            : "/admin/mobile/dashboard",
        );
      } else {
        if (!user.desktop_access) {
          navigate("/access-denied");
          return;
        }
        navigate(
          user.role === 1
            ? "/admin/desktop/dashboard"
            : "/user/desktop/dashboard",
        );
      }
    }
  }, [user, navigate]);



  return (
    <div className="login-page">
      {/* DESKTOP LAYOUT */}
      <div className="desktop-login-layout">
        <div
          className="desktop-left-panel"
          style={{ backgroundImage: `url(${deskLogo})` }}
        />
        <div
          className="desktop-right-panel"
          style={{ backgroundImage: `url(${deskBg})` }}
        >
          <div className="desktop-overlay" />
          <div className="desktop-login-card">
            <img src={loginLogo} alt="Login" className="desktop-login-icon" />
            <img
              src={attendanceTextLogo}
              alt="Attendance"
              className="desktop-attendance-logo"
            />

            <div className="desktop-form-wrapper">
              <form onSubmit={handleLogin}>
                <div className="desktop-input-group">
                  <label>Company Code</label>
                  <input
                    type="text"
                    name="company_code"
                    autoComplete="off"
                    required
                    disabled={submitting}
                    placeholder="Enter company code"
                    value={companyCode}
                    onChange={(e) => setCompanyCode(e.target.value)}
                  />
                </div>
                <div className="desktop-input-group">
                  <label>Employee Code</label>
                  <input
                    type="text"
                    name="employee_code"
                    autoComplete="username"
                    required
                    disabled={submitting}
                    placeholder="Enter employee code"
                    value={employeeCode}
                    onChange={(e) => setEmployeeCode(e.target.value)}
                  />
                </div>
                <div className="desktop-input-group">
                  <label>Password</label>

                  <div className="password-input-wrapper">
                    <input
                      type={showDesktopPassword ? "text" : "password"}
                      name="password"
                      autoComplete="current-password"
                      required
                      disabled={submitting}
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />

                    <button
                      type="button"
                      className="password-toggle-btn"
                      onClick={() => setShowDesktopPassword((prev) => !prev)}
                      aria-label={
                        showDesktopPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showDesktopPassword ? <FiEye /> : <FiEyeOff />}
                    </button>
                  </div>
                </div>
                <button type="submit" className="desktop-login-btn" disabled={submitting}>
                  {submitting ? "Signing in..." : "Login"}
                </button>
              </form>

              <p className="desktop-terms">
                *By continuing to use this site, you agree to the{" "}
                <Link to="/privacy-policy">Privacy Policy.</Link>
              </p>

              <div className="desktop-social-icons">
                <div className="desktop-social-box">
                  <img src={fb} alt="Facebook" />
                </div>
                <div className="desktop-social-box"><img src={linkedin} alt="LinkedIn" /></div>
                <div className="desktop-social-box"> <img src={insta} alt="Insta" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MOBILE LAYOUT */}
      <div className="mobile-login-layout">
        <WaveBackground />

        <div className="m-login-hero">
          <div className="m-powered-by">
            <span className="m-powered-label">Powered by</span>
            <span
              className="m-powered-logo"
              role="img"
              aria-label="iWORKKZ"
              style={{
                WebkitMaskImage: `url("${iworkkzlogo}")`,
                maskImage: `url("${iworkkzlogo}")`,
              }}
            />
          </div>

          <div className="m-app-brand">
            <div className="m-app-icon">
              <img src={attendanceIconWhite} alt="iAttendance" />
            </div>
            <AttendanceTextLogo
              className="m-app-text-logo"
              viewBox="0 0 432 57"
              role="img"
              aria-label="iAttendance"
            />
          </div>

          <p className="m-welcome">Welcome Back,</p>
          <h1 className="m-headline">Log In, Get Going!</h1>
        </div>

        <div className="m-login-card">
          <form className="m-login-form" onSubmit={handleLogin}>
            <div className="m-input-group">
              <label>Company Code</label>
              <input
                type="text"
                name="company_code"
                autoComplete="off"
                required
                disabled={submitting}
                placeholder="Enter company code"
                value={companyCode}
                onChange={(e) => setCompanyCode(e.target.value)}
              />
            </div>
            <div className="m-input-group">
              <label>Employee Code</label>
              <input
                type="text"
                name="employee_code"
                autoComplete="username"
                required
                disabled={submitting}
                placeholder="Enter employee code"
                value={employeeCode}
                onChange={(e) => setEmployeeCode(e.target.value)}
              />
            </div>
            <div className="m-input-group">
              <label>Password</label>

              <div className="m-password-wrapper">
                <input
                  type={showMobilePassword ? "text" : "password"}
                  name="password"
                  autoComplete="current-password"
                  required
                  disabled={submitting}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <button
                  type="button"
                  className="m-password-toggle"
                  onClick={() => setShowMobilePassword((prev) => !prev)}
                  aria-label={
                    showMobilePassword ? "Hide password" : "Show password"
                  }
                >
                  {showMobilePassword ? <FiEye /> : <FiEyeOff />}
                </button>
              </div>
            </div>
            <button type="submit" className="m-login-btn" disabled={submitting}>
              {submitting ? "Signing in..." : "Log - In"}
            </button>
          </form>

          <p className="m-terms">
            *By continuing to use this site, you agree to the{" "}
            <Link to="/privacy-policy">Privacy Policy.</Link>
          </p>

          <div className="m-follow">
            <span className="m-follow-title">Follow Us</span>
            <div className="m-social-icons">
              <div className="m-social-box" aria-label="Facebook">
                <FaFacebookF />
              </div>
              <div className="m-social-box" aria-label="LinkedIn">
                <FaLinkedinIn />
              </div>
              <div className="m-social-box" aria-label="Instagram">
                <FaInstagram />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
